import { render } from "./error404.vue?vue&type=template&id=7df27030&scoped=true&ts=true"
import script from "./error404.vue?vue&type=script&lang=ts"
export * from "./error404.vue?vue&type=script&lang=ts"

import "./error404.vue?vue&type=style&index=0&id=7df27030&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df27030"]])

export default __exports__